module.exports = __webpack_public_path__ + "static/mourya-22a576ef71eb3c10602ad0464c31873c.jpg";